import React, { useEffect, useState } from 'react'
import lodash from 'lodash'
import Chart from './components/Chart'
import useGlobalConfigStore from '@/stores/globalConfig'
import useStationStore from '@/stores/oneStation'
import { useParams } from 'react-router-dom'
import MqttServer from '@/utils/mqttUtil'
import { getDeviceData } from '@/utils/getData'
import { FunGroup, StationVirtualPoint } from '@/type/stationType'
import ItemValue from './components/ItemValue'

const Gen: React.FC = () => {
  const { deviceId } = useParams()
  const mqtt_serve = useStationStore(state => state.mqtt_serve)
  const device = useStationStore(state => state.device)
  const station_virtual_label = useStationStore(state => state.station_virtual_label)
  const initFinished = useGlobalConfigStore(state => state.initFinished)
  let targetGroup: FunGroup | undefined,
    mqtt: MqttServer | undefined,
    uuid: string = '',
    id: number = 0
  const [data, setData] = useState<{ label: string; value: string | number; unit: string }[]>([])
  const [chartPoints, setChartPoints] = useState<StationVirtualPoint[]>([])
  const [chartDeviceId, setChartDeviceId] = useState<number>(0)

  const getData = async () => {
    if (targetGroup) {
      let res: any
      try {
        res = await getDeviceData(
          [{ device_id: Number(id), defines: targetGroup.funs.map(item => item.fun_code) }],
          mqtt as MqttServer,
          uuid
        )
        if (res.code === 1) {
          res.data[0].datas.forEach((item: { id: number; property_code: string; value: string }) => {
            let targetFun = targetGroup?.funs.find(fun => fun.fun_code === item.property_code)
            if (targetFun) {
              targetFun.value = Number(item.value)
            }
          })
          // console.log(targetGroup)
        }
      } catch (e) {
        console.log(e)
      }
      const funs = targetGroup.funs

      setData(funs.map(item => ({ label: item.fun_name, value: item.value, unit: item.unit })))

      const targetLabel = station_virtual_label.find(item => item.type === 'cf')
      if (targetLabel) {
        setChartPoints(
          targetLabel.points.filter(
            item => item.property_code === 'I' || item.property_code === 'KRA' || item.property_code === 'P'
          )
        )
      }
      setChartDeviceId(id)
    }
  }

  useEffect(() => {
    if (initFinished) {
      const targetDevice = lodash.cloneDeep(device.find(item => item.id === Number(deviceId)))
      if (targetDevice) {
        targetGroup = targetDevice.fun_group?.find(item => item.group_name === 'Gen')
        mqtt = mqtt_serve[targetDevice.mqtt_server_id]
        uuid = targetDevice.iot_gateway_uuid
        id = targetDevice.device_id
      }
      getData()
    }
  }, [initFinished])

  return (
    <div id='Gen'>
      <div className='items'>
        {data.map((item, index) => (
          <div className='item' key={item.label}>
            <ItemValue {...item} />
            {index % 4 == 0 && <div className='su'></div>}
          </div>
        ))}
      </div>
      <div className='Gen-charts'>
        <Chart deviceId={chartDeviceId} points={chartPoints} />
      </div>
    </div>
  )
}

export default Gen

// import React from "react"
// import NumberScroller from "@/components/NumberScroller"
// import Charts from "./components/Charts"

// const ComponentName: React.FC = (props) => {
//   const testData = [
//     { label: "Year_discharge_powerWh:", value: "100", unit: "kWh" },
//     { label: "Year_load_power:", value: "200", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_load_power:", value: "200", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//   ]

//   return (
//     <div id="Gen">
//       <div className="my-data">
//         <div className="items">
//           {testData.map((v, k) => (
//             <div className="item">
//               <div className="itemValue">
//                 <div className="itemValue-label">{v.label}</div>
//                 <div className="itemValue-value">
//                   <NumberScroller targetNumber={v.value} />
//                   <span>{v.unit}</span>
//                 </div>
//               </div>
//               {k % 4 == 0 && <div className="su"></div>}
//             </div>
//           ))}
//         </div>
//       </div>
//       <div className="Gen-charts">
//         <Charts />
//       </div>
//     </div>
//   )
// }

// export default ComponentName
